import { Navigate, useLocation } from "react-router-dom";
import { usePageSettings, isRouteVisible } from "@/lib/page-settings";

/**
 * Blocks rendering of a route when the admin dashboard has marked it
 * hidden via GET /api/pages. Redirect happens before the page paints,
 * so visitors never see a flash of hidden content.
 *
 * - While settings are loading for the first time, renders nothing.
 *   This prevents a brief flash of a hidden page's content on initial
 *   hard-load. Subsequent client-side navs hit the in-memory cache
 *   and render instantly.
 * - On API error, the underlying context falls back to "all visible,"
 *   so this guard becomes a no-op (spec requirement).
 */
export function PageGuard({ children }) {
  const { status, pages } = usePageSettings();
  const location = useLocation();

  if (status === "loading") return null;

  if (!isRouteVisible(location.pathname, pages)) {
    return <Navigate to="/" replace />;
  }

  return children;
}
